// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".select-warp[data-v-6a314b13] {\n  display: flex;\n  justify-content: flex-start;\n}\n.select-warp .el-select[data-v-6a314b13]:nth-child(3) {\n  margin-right: 0 !important;\n}\n.lable-color-correct[data-v-6a314b13] {\n  color: #f00;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
